import markdownit from "markdown-it";
import { CompleteEvent, Model } from "survey-core";
import "survey-core/survey-core.css";
import { Survey } from "survey-react-ui";
import { useAuth } from "@/hooks/useAuth";
import { themeJson } from "./theme";
import { surveyJson } from "@/config/survey.config";
import { UserData } from "@/types/user-data";
import { useNavigate } from "react-router-dom";

const survey = new Model(surveyJson);
survey.applyTheme(themeJson);

const converter = markdownit({
  html: true,
});

survey.onTextMarkdown.add((_, options) => {
  const str = converter.renderInline(options.text);
  options.html = str;
});

export const SurveyPage = () => {
  const navigate = useNavigate();
  const { updateUserSurvey } = useAuth();

  survey.onComplete.add(async (survey: Model, options: CompleteEvent) => {
    await updateUserSurvey(survey.data as UserData["survey"]);
    setTimeout(() => {
      navigate("/");
    }, 1000);
  });

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-4 md:p-10 ">
      <div className="flex w-full h-full max-w-5xl shrink-0 items-center justify-center rounded-2xl border text-card-foreground shadow-sm overflow-auto my-4 md:my-8 overflow-y-auto">
        <Survey model={survey} />
      </div>
    </div>
  );
};
